import { render, staticRenderFns } from "./Usermanagement.vue?vue&type=template&id=f84c5602&scoped=true"
import script from "./Usermanagement.vue?vue&type=script&lang=js"
export * from "./Usermanagement.vue?vue&type=script&lang=js"
import style0 from "./Usermanagement.vue?vue&type=style&index=0&id=f84c5602&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84c5602",
  null
  
)

export default component.exports